import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import adminHttp from "../../../utils/adminHttp";


type Payload = {
  userId: string;

}

export const useUpdateAdminPatientStatus = () => {
  const queryClient = useQueryClient();
  const { mutate, data, variables, ...rest } = useMutation({
    mutationKey: ['update admin patient status'],
    mutationFn: async ({ ...userId }: Payload) => {
      const response = await adminHttp.patch(`patients/active/${userId}`);
      return response.data;
    },

    onSuccess: () => {
      toast.success(
        `updated successfully`,
        { toastId: "customId" }
      );
      queryClient.invalidateQueries({
        queryKey: ["get admin provider list"] as const
      });
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error.response?.statusText || `Error updating data`,
          { toastId: "customId" }
        );

      } else {
        toast.error(
          error?.message
          || "Error processing your request",
        );
      }
    },
  });

  return {
    updatePatientStatus: mutate,
    data,
    variables,
    ...rest,
  };
}